import axios from "@axios";
import {useUtils as useI18nUtils} from "@core/libs/i18n";
import useLayoutSlots from '@/composables/layoutSlots';
import {SLOT_TYPES} from "@/config/layoutConfig";
import {useToast} from "vue-toastification/composition";
import ToastificationContent
  from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import useDmp from "./helpers/useDmp";
import { useTranslates } from "@/utils/useTranslates";

export default function useAlarmsParents() {
  const {t} = useI18nUtils();
  const {setSlotData} = useLayoutSlots();
  const toast = useToast();

  const trans = {
    "messages.activate.title": t("messages.activate.title"),
    "messages.activate.body": t("messages.activate.body"),
    "messages.activate.activated_correctly": t("messages.activate.activated_correctly"),
    "messages.activate.confirm": t("messages.activate.confirm"),
    "messages.activate.activated_correctly_confirm": t(
      "messages.activate.activated_correctly_confirm"
    ),
    "actions.cancel": t("actions.cancel"),
    "messages.activate.error": t("messages.activate.error"),

    "messages.desactivate.title": t("messages.desactivate.title"),
    "messages.desactivate.body": t("messages.desactivate.body"),
    "messages.desactivate.desactivated_correctly": t(
      "messages.desactivate.desactivated_correctly"
    ),
    "messages.desactivate.confirm": t("messages.desactivate.confirm"),
    "messages.desactivate.desactivated_correctly_confirm": t(
      "messages.desactivate.desactivated_correctly_confirm"
    ),
    "messages.desactivate.error": t("messages.desactivate.error"),
    "messages.loading.title": t("messages.loading.title"),
    "messages.activate.activating": t("messages.activate.activating"),
    "messages.desactivate.deactivating": t("messages.desactivate.deactivating"),
    "messages.actions.apply_state": t("messages.actions.apply_state"),
    "messages.actions.no_action_selected": t("messages.actions.no_action_selected"),
    "messages.actions.executing": t("messages.actions.executing"),
    "messages.actions.in": t("messages.actions.in"),
    "messages.actions.executed_successfully": t("messages.actions.executed_successfully"),
    "messages.actions.error_executing": t("messages.actions.error_executing"),
    "dmp.arm": t("dmp.arm"),
    "dmp.disarm": t("dmp.disarm"),
    "dmp.messages.areYouSureTo": t("dmp.messages.areYouSureTo"),
  };

  const {handleMultipleActions} = useDmp(trans);

  const titleDevice = (device) => {
    let title;

    if (device.status) {
      title = `${device.text} (${device.status})`;
    } else {
      title = device.text;
    }

    return title;
  }

  const iconPanelStatus = (status) => {
    const {camera_type} = status;

    if (camera_type.includes('PacomSite')) {
      if (status.status === "Online") {
        return "custom custom-camera-online";
      } else {
        return "custom custom-camera-offline";
      }
    }

    if (status.camera.active && status.status === "Online") {
      return "custom custom-camera-online";
    } else if (status.camera.active && status.status !== "Online") {
      return "custom custom-circle-offline-orange";
    } else if (!status.camera.active && status.status === "Online") {
      return "custom custom-camera-offline";
    } else if (!status.camera.active && status.status !== "Online") {
      return "custom custom-camera-offline";
    }

  };

  const setChildrenData = (item) => {
    if (item && item.tag === "alarms_bridge" && item.type !== "parent-children") {
      item.children = [];

      const devices = item.data;

      devices.forEach((dataItem) => {
        let child_device;

        if (!dataItem.subsystem_tree_data) return;
        const {subsystem_tree_data: {root_data, actions: devices}} = dataItem;
        if (devices && devices.length > 0) {
          child_device = {
            id: dataItem.id_camera_proxy,
            text: root_data.text,
            icon: dataItem.device ? iconPanelStatus(dataItem.device) : 'custom custom-camera-online',
            tag: "alarms_bridge",
            type: "parent-children",
            visible: true,
            children: devices.map(device => ({...device})),
            data: devices.map(device => ({...device}))
          };
        }
        item.addChild(child_device);
      });
    } else {
      setChildrenDataAlarmsBridge(item);
    }
  };

  const setChildrenDataAlarmsBridge = (item) => {
    if (!item) return;
    item.children = [];
    const devices = item.data;

    if (devices.length > 0) {
      devices.forEach(device => {
        const children = device.children.map(child => ({...child}));
        const child_device = {
          id: device.id,
          text: titleDevice(device),
          icon: "custom custom-dmt-area",
          tag: device.tag,
          type: "parent-child",
          visible: true,
          children
        };

        item.addChild(child_device);
      });
    }
    item.data = [];
  };

  const actions = async (item, vueInstance, tenantId = null) => {
    if (item.tag !== 'alarm-bridge-action' && item.tag !== 'alarm-bridge-device') {
      return
    }
    console.log('actions', item);
    // Si device_type iene más de una acción, entonces es un zone, zone24h u un output con varias acciones.
    const isZoneWithMultipleActions =
      item.data.actions &&
      item.data.actions.length > 0

    if (!isZoneWithMultipleActions) {
      console.log('item', item)
      try {
        let areaText = item.status ? trans["dmp.disarm"] : trans["dmp.arm"];
        let actionText = item.status ? trans["messages.desactivate.title"] : trans["messages.activate.title"]
        let confirm = item.status ? trans["messages.desactivate.confirm"] : trans["messages.activate.confirm"]

        let actionTitle = item.device_type === "area" ? areaText : actionText;

        const result = await vueInstance.$swal({
          title: useTranslates(trans["dmp.messages.areYouSureTo"], { action: actionTitle, device: item.text }),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: confirm,
          cancelButtonText: trans["actions.cancel"],
          customClass: {
            confirmButton: "btn btn-primary text-capitalize",
            cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
          },
          buttonsStyling: false,
        })

        if (result.isConfirmed) {
          const toastId = toast(
            {
              component: ToastificationContent,
              props: {
                title: trans["messages.activate.activating"] + ` ${item.text}`,
                icon: "LoaderIcon",
                variant: "warning",
              },
              iconClass: "loader-icon-toast",
            },
            {timeout: false}
          )

          const {data} = await axios.get(item.data.url)

          if (data.success) {
            item.status = !item.status
          }

          await vueInstance.$swal({
            title: trans["messages.activate.activated_correctly"],
            text: trans["messages.activate.activated_correctly_confirm"],
            icon: "success",
          })
          // Actualizar store
          // store.dispatch("grid/setAlarmsBridgeData", {
          //   data: {tenantId, alarmsBridgeId: item.idAlarmsBridgeTreeItem, action: item},
          // })
        }
      } catch (error) {
        console.error('Error executing action:', error.response)
        await vueInstance.$swal({
          title: error.response?.data?.data?.error || 'Error',
          text: trans["messages.activate.error"],
          icon: "error",
        })
      }
    } else {
      // Caso: dispositivo "zone" con múltiples acciones, delegamos la lógica a useDmp
      await handleMultipleActions(item, vueInstance, tenantId);
    }
  }

  const tooltipAction = async (item, vueInstance) => {
    if (item.tag === 'alarm-bridge-action' || item.tag === 'alarm-bridge-device') {
      await vueInstance.$root.$emit('bv::show::tooltip', item.id);
    }
  };

  const updateAlarmsBridgeDataOfTreeItem = (facilitieId) => {
    const id = `unit_${facilitieId}_alarms_bridge`
  }

  return {setChildrenData, actions, tooltipAction};
}
